import { FishType } from '@/game/infos/fishInfos';

export enum BodyType {
	Shark,
	KillerWhale,
	HammerHead,
	GreatWhiteShark,
	SerialKillerWhale,
	HammeredHead,
	Megalodon,
	PsychoKillerWhale,
	WhammyHead,
	Whale,
	BlueWhale,
	Jomama,
	MantaRay,
	MantraRay,
	BlueRay,
	Pufferfish,
	Porcupinefish,
	Onifugu,
	Dolphin,
	CommonDolphin,
	SpinnerDolphin,
	Goldfish,
	Goldenfish,
	Diamondfish,
	Narwhal,
	Beluga,
	ArchBeluga,
	DumboOctopus,
	Octopus,
	Kraken,
	KrakenRun,
	MorayEel,
	GulperEel,
	ElectricEel,
	SeaTurtle,
	LeatherbackTurtle,
	SnappingTurtle,
}
export function translateFishTypeToSf2(bodyType: BodyType) {
	if (bodyType > BodyType.KrakenRun) {
		return bodyType;
	}
	if (bodyType === BodyType.SerialKillerWhale) {
		return FishType.SerialKillerWhale;
	}
	if (bodyType === BodyType.PsychoKillerWhale) {
		return FishType.PsychoKillerWhale;
	}
	if (bodyType === BodyType.Megalodon) {
		return FishType.Megalodon;
	}
	if (bodyType === BodyType.Shark) {
		return FishType.BlueShark;
	}
	if (bodyType === BodyType.HammerHead) {
		return FishType.HammerHead;
	}
	if (bodyType === BodyType.KillerWhale) {
		return FishType.KillerWhale;
	}
	if (bodyType === BodyType.HammeredHead) {
		return FishType.HammeredHead;
	}
	if (bodyType === BodyType.GreatWhiteShark) {
		return FishType.GreatWhiteShark;
	}
	if (bodyType === BodyType.WhammyHead) {
		return FishType.WhammyHead;
	}
	return bodyType + 1;
}
export function translateFishTypeToSf1(bodyType: FishType) {
	if (bodyType > BodyType.KrakenRun) {
		return bodyType;
	}
	if (bodyType === FishType.SerialKillerWhale) {
		return BodyType.SerialKillerWhale;
	}
	if (bodyType === FishType.PsychoKillerWhale) {
		return BodyType.PsychoKillerWhale;
	}
	if (bodyType === FishType.Megalodon) {
		return BodyType.Megalodon;
	}
	if (bodyType === FishType.BlueShark) {
		return BodyType.Shark;
	}
	if (bodyType === FishType.HammerHead) {
		return BodyType.HammerHead;
	}
	if (bodyType === FishType.KillerWhale) {
		return BodyType.KillerWhale;
	}
	if (bodyType === FishType.HammeredHead) {
		return BodyType.HammeredHead;
	}
	if (bodyType === FishType.GreatWhiteShark) {
		return BodyType.GreatWhiteShark;
	}
	if (bodyType === FishType.WhammyHead) {
		return BodyType.WhammyHead;
	}
	return bodyType - 1;
}
